import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppMetaService } from '../../core/services/app-meta.service';
import { AuthService } from '../../core/services/auth.service';
import { BreadcrumbComponent } from '../../shared/breadcrumb/breadcrumb.component';
import { HeaderToolbarComponent } from '../../shared/components/header-toolbar/header-toolbar.component';

@Component({
  selector: 'app-app-shell',
  standalone: true,
  imports: [HeaderToolbarComponent, BreadcrumbComponent, RouterOutlet],
  templateUrl: './app-shell.component.html',
})
export class AppShellComponent {
  private readonly appMetaService = inject(AppMetaService);
  private readonly authService = inject(AuthService);

  readonly version = this.appMetaService.version;
  readonly versionDate = this.appMetaService.versionDate;
  readonly envLabel = this.appMetaService.environment;
  readonly isAuthenticated = this.authService.isAuthenticated;

  onLogout(): void {
    this.authService.logout();
  }
}

